import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { H1, Body } from '../components/ui/Typography';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found - RentFi</title>
        <meta name="description" content="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
        <div className="max-w-md w-full text-center">
          <H1 className="text-primary mb-4">404 - Page Not Found</H1>
          <Body className="text-gray-600 mb-8">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </Body>
          <Link to="/" className="btn-primary">
            Return Home
          </Link>
        </div>
      </div>
    </>
  );
}